import { render } from "./cgetel.vue?vue&type=template&id=700d4ef2&scoped=true"
import script from "./cgetel.vue?vue&type=script&lang=js"
export * from "./cgetel.vue?vue&type=script&lang=js"

import "./cgetel.vue?vue&type=style&index=0&id=700d4ef2&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700d4ef2"]])

export default __exports__